import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const ArchiveIcon = ({
  width = 16,
  height = 16,
  stroke = '#52575C',
  fill = 'none',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_311_25289)">
      <path
        d="M14 5.33301V13.9997H2V5.33301"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3333 2H0.666626V5.33333H15.3333V2Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66663 8H9.33329"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_311_25289">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
